<template>
  <div>
    <div class="order-container padding-lr-8 padding-top-16" v-if="order.bizId">
      <div class="bg-white padding-12 radius">
        <div class="flex justify-between padding-bottom-12">
          <div class="text-bold text-16">订单服务</div>
          <div
            class="border radius padding-tb-6 padding-lr-12 text-12"
            style="border-radius: 20px"
            @click="$router.push('/order/list')"
          >
            切换行程
          </div>
        </div>
        <order :customClass="['bg-body']" :data="order"></order>
      </div>
    </div>

    <div
      class="margin-lr-8 padding-12 margin-tb-16 bg-white flex align-center justify-between radius"
      @click="$router.push('/service/progress')"
    >
      <div class="flex align-center">
        <van-icon name="underway-o" size="18" />
        <span class="margin-left-4">服务进度</span>
      </div>
      <van-icon color="var(--primary)" name="arrow" />
    </div>
    <div class="margin-lr-8 bg-white padding-12 radius">
      <div class="flex justify-between align-center">
        <div class="text-16 text-bold">猜你想问</div>
        <div class="text-primary flex align-center" @click="onRefreshGussQs">
          <van-icon name="replay" />
          <span class="margin-left-4">换一换</span>
        </div>
      </div>
      <van-cell-group class="margin-top-12">
        <van-cell
          v-for="item in guessQsList[activeGussQsIndex]"
          :key="item.is"
          :title="item.title"
          @click="$router.push(`/service/detail/${item.id}`)"
        >
          <template #title>
            <div class="flex align-center">
              <van-image
                width="24"
                height="24"
                :src="require('assets/images/kf/qs-list-icon.png')"
              ></van-image>
              <span class="custom-title margin-left-4">{{ item.title }}</span>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>

    <div class="margin-lr-8 margin-tb-16 bg-white radius">
      <div class="text-16 text-bold padding-12 margin-bottom-12">常见问题</div>
      <van-tabs v-model="activeName" border @change="onChange">
        <van-tab title="顺风车乘客" name="sfc_passenger">
          <custom-tab :data="ckQsInfo" :key="activeName"></custom-tab>
        </van-tab>
        <van-tab title="顺风车车主" name="sfc_driver">
          <custom-tab :data="czQsInfo" :key="activeName"></custom-tab>
        </van-tab>
        <van-tab title="网约车" name="online_car_hailing">
          <custom-tab :data="wycQsInfo" :key="activeName"></custom-tab>
        </van-tab>
      </van-tabs>
    </div>

    <div class="padding-16">
      <van-button block type="primary" @click="kfBtnClick">联系客服</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tab, Tabs, Cell, CellGroup } from 'vant'
import { mapState, mapMutations } from 'vuex'

import CustomTab from './component/tab'
import Order from 'views/order/components/order-item'

import { fetchGuessQsList, fetchQsList } from 'api/service'
import { getList as getOrderList } from 'api/order'

import { KF_PHONE } from '@/utils/constant'
import { handleApp } from '@/utils/handle_app'

Vue.use(Tab).use(Tabs).use(Cell).use(CellGroup)

const qsTagInfo = {
  order: '订单问题',
  rule: '规则问题',
  count: '账户问题',
  cost: '费用问题',
  safe: '安全问题',
  trip: '行程问题',
  other: '其他问题'
}
export default {
  components: {
    CustomTab,
    Order
  },
  data (options) {
    return {
      activeName: 'sfc_passenger',
      activeGussQsIndex: 0,
      guessQsList: [],

      ckQsInfo: {},
      czQsInfo: {},
      wycQsInfo: {}
    }
  },
  computed: {
    ...mapState('service', ['order'])
  },
  created () {
    if (!this.order.bizId) {
      this.getOrderList()
    }
    this.fetchGuessQsList()
    this.getQsLIst()
  },
  methods: {
    ...mapMutations('service', ['changeOrder']),
    async fetchGuessQsList () {
      const list = await fetchGuessQsList()
      const activeList = []
      for (let i = 0; i < list.length; i += 5) {
        activeList.push(list.slice(i, i + 5))
      }
      this.guessQsList = activeList
    },

    async getQsLIst () {
      const list = await fetchQsList({
        code: this.activeName
      })
      const qsInfo = {}
      list.forEach((item) => {
        item.name = item.title
        let keyName = ''
        for (const key in qsTagInfo) {
          if (item.typeName === qsTagInfo[key]) {
            keyName = key
          }
        }

        if (!Reflect.has(qsInfo, keyName)) {
          qsInfo[keyName] = {
            name: item.typeName,
            list: [item]
          }
        } else {
          qsInfo[keyName].list.push(item)
        }
      })

      switch (this.activeName) {
        case 'sfc_passenger':
          this.ckQsInfo = qsInfo
          break
        case 'sfc_driver':
          this.czQsInfo = qsInfo
          break
        case 'online_car_hailing':
          this.wycQsInfo = qsInfo
      }
    },

    async getOrderList () {
      const res = await getOrderList({
        current: 1,
        size: 1
      })
      if (res.records.length) {
        this.changeOrder(res.records[0])
      }
    },

    onRefreshGussQs () {
      if (this.activeGussQsIndex < this.guessQsList.length - 1) {
        this.activeGussQsIndex++
      } else {
        this.activeGussQsIndex = 0
      }
    },
    onChange () {
      this.getQsLIst()
    },

    kfBtnClick () {
      handleApp('call', { phone: KF_PHONE }, () => {
        window.location.href = `tel:${KF_PHONE}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-container {
  background-image: url(~assets/images/kf/bg.png);
  background-size: 100% 100%;
}
</style>
